import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import useDepartmentSelector from "../../../TCPForms/hooks/useDepartmentSelector";
import { toTitleCase } from "../../../../../utils";


const getSelfApprovalMapSubmissionData = (t, id = null) => {
    const tenantId = Digit.ULBService.getStateId() || "up";
    const { isSuccess: isMdmsSuccess, data: mdmsData } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["RiskTypeComputation"]);

    const fetchApplicationData = async () => {
        return await Digit.OBPSService.BPASearch(tenantId, { applicationId: id, isEmployee: false });
    };
    const { data, isLoading: isAppDataLoading, isSuccess } = useQuery({ queryKey: [id], queryFn: fetchApplicationData, enabled: isMdmsSuccess });
    // let applicationData = isSuccess && data?.BPA?.[0];
    let applicationData = data?.BPA?.[0] || {};

    if (id && isSuccess) {
        // Fetch application data for edit flow
        applicationData = {
            ...applicationData,
            applicationDate: applicationData?.applicationDate || null,
            occupancy: applicationData?.occupancy || null,
            edcrNumber: applicationData?.edcrNumber || null,
            totalBuildUpArea: applicationData?.totalBuildUpArea,
            totalProposedArea: applicationData?.totalProposedArea,
            totalExistingBuiltUpArea: applicationData?.totalExistingBuiltUpArea,
            maximumPermissibleGroundCoverage: applicationData?.totalCoverageArea?.toFixed(2) || null,
            typeofArea: toTitleCase(applicationData?.landUseZone),
            propertyType: toTitleCase(applicationData?.applicantPropertyType),
            // proposal: applicationData?.proposalSubmittedFor || null,
            revenueVillageMohal: applicationData?.mauza || null,
            khataNo: applicationData?.khataNo || null,
            khatauniNo: applicationData?.khatauniNo || null,
            plotArea: applicationData?.plotArea || 0,
            totalPlotArea: applicationData?.plotArea || 0,
            blocks: applicationData?.blocks || null,
            noOfBlocks: applicationData?.blocks?.length || 0,
            premiumFAR: applicationData?.premiumFarArea || 0,
            demolitionArea: applicationData?.demolitionArea || null,
            parkingArea: applicationData?.parkingDetails?.overAllParkingArea || 0,
            parkingFloorNo: applicationData?.parkingDetails?.parkingFloorNo || 0,
            activeTab: Digit?.SessionStorage.get("MS_CURRENT_TAB") || 0,
            riskType: applicationData?.riskType,
            //applicationData: applicationData,
            scrutinyFlow: applicationData?.scrutinyFlow || (applicationData?.edcrNumber && "EDCR"),

            planReport: applicationData?.planReport,
            updatedDxfFile: applicationData?.updatedDxfFile,
            dxfFile: applicationData?.dxfFile,
            natureOfConstruction: applicationData?.natureOfConstruction || applicationData?.natureOfConstruction,
            proposalType: applicationData?.proposalType,
            sanctionDate: applicationData?.sanctionDate,
            sanctionNumber: applicationData?.sanctionNumber,
            noOfPlots: applicationData?.noOfPlots,
            plotNumbers: applicationData?.plotNumbers,
            district: applicationData?.district,
            sectorNoPlotNo: applicationData?.sectorNoPlotNo,
            tehsil: applicationData?.tehsil,
            revenueVillage: applicationData?.revenueVillage,
            landMark: applicationData?.landMark,
            schemeName: applicationData?.schemeName,
            buildingClassification: applicationData?.buildingClassification,
            otherbuildingClass: applicationData?.otherbuildingClass,
            planOn: applicationData?.planOn,
            buildingHeight: applicationData?.buildingHeight,
            projectType: applicationData?.projectType,
            isRevised: applicationData?.isRevised,
            prevFileNo: applicationData?.prevFileNo,
            isSpecialProject: applicationData?.isSpecialProject,
            typeOfProject: applicationData?.typeOfProject,
            plotSubdivided: applicationData?.plotSubdivided,
            plotNo: applicationData?.plotNo,
            needCompounding: applicationData?.needCompounding,
            plotLeaseHold: applicationData?.plotLeaseHold,
            isApprovedLayout: applicationData?.isApprovedLayout,
            isSpecialGroundCoverage: applicationData?.isSpecialGroundCoverage,
            isSpecialFAR: applicationData?.isSpecialFAR,
            constructionType: applicationData?.constructionType,
            layoutsanctionNumber: applicationData?.layoutsanctionNumber,
            layoutsanctionDate: applicationData?.layoutsanctionDate,
            groundCoverage: applicationData?.groundCoverages,
            far: applicationData?.fars,
            isSetbackRequired: applicationData?.isSetbackRequired,
            setbackFronts: applicationData?.previousSetbackFront,
            setbackRears: applicationData?.previousSetbackRear,
            setbackSide1: applicationData?.previousSetbackSide1,
            setbackSide2: applicationData?.previousSetbackSide2,
            zoneType: applicationData?.zoneType,
            isMetroCity: applicationData?.isMetroCity,
            subZoneType: applicationData?.subZoneType,
            primaryUse: applicationData?.primaryUse,
            activityProposed: applicationData?.activityProposed,
            communityParking: applicationData?.communityParking,
            anyotherCondition: applicationData?.anyotherCondition,
            khasraNo: applicationData?.khasraNo,
            sectorNo: applicationData?.sectorNo,
            fastPASId: applicationData?.land_Id,
            schemeType: applicationData?.descriptionOfLand?.schemeType,
            planOn: applicationData?.planOn,
            typeOfArea: applicationData?.descriptionOfLand?.developmentArea,
            latitude: applicationData?.descriptionOfLand?.latitude,
            longitude: applicationData?.descriptionOfLand?.longitude,
            roadwidth: applicationData?.descriptionOfLand?.roadWidths?.[0]?.value,
            approachRoadWidth: applicationData?.descriptionOfLand?.approachRoadWidths?.[0]?.value,
            khasraDetails: applicationData?.khasraDetails,
            mapSubDetails: { proposalTypeFAR: applicationData?.mapSubDetails?.proposalTypeFAR, fireFighting: applicationData?.mapSubDetails?.fireFighting },
            descriptionOfLand: applicationData?.descriptionOfLand,
            landInfo: applicationData?.landInfo || applicationData?.landInfo,
        };
        console.log("applicationDataINSIDEIIEI", applicationData);
        return { applicationData, isAppDataLoading };
    }

    if (id && !isSuccess) {
        return {
            applicationData: {},
            isAppDataLoading,
        };
    }

    // Create Application data object for create flow
    const applicationType = "FORM_MAP";
    const userInfo = Digit.UserService.getUser();
    const { documents } = useSelector((state) => state.form12);
    const [, applicationFlow] = useDepartmentSelector();

    const applicantName = toTitleCase(applicationData?.applicantName);

    applicationData = {
        ...applicationData,
        tenantId,
        applicationNo: applicationData?.applicationNumber || null,
        applicationDate: applicationData?.applicationDate || null,
        applicationSubType: applicationData?.applicationSubType || null,
        occupancy: applicationData?.occupancy || null,
        edcrNumber: applicationData?.edcrNumber || null,
        totalBuildUpArea: applicationData?.totalBuildUpArea,
        totalProposedArea: applicationData?.totalProposedArea,
        totalExistingBuiltUpArea: applicationData?.totalExistingBuiltUpArea,
        maximumPermissibleGroundCoverage: applicationData?.totalCoverageArea?.toFixed(2) || null,
        typeofArea: toTitleCase(applicationData?.landUseZone),
        propertyType: toTitleCase(applicationData?.applicantPropertyType || applicationData?.planInfoProperties?.PROPERTY_TYPE),
        proposal: applicationData?.proposalSubmittedFor || applicationData?.proposal || null,
        revenueVillageMohal: applicationData?.mauza || null,
        khataNo: applicationData?.khataNo || null,
        khatauniNo: applicationData?.khatauniNo || null,
        plotArea: applicationData?.plotArea || applicationData?.plot?.area || 0,
        plotAreaDoc: applicationData?.plotAreaDoc,
        plotAreaPos: applicationData?.plotAreaPossession,
        siteAddress: applicationData?.landAddress,
        totalPlotArea: applicationData?.plotArea || 0,
        blocks: applicationData?.blocks || null,
        basicFAR: applicationData?.basicFAR || 0,
        purchasableFAR: applicationData?.purchasableFAR || 0,
        premiumFAR: applicationData?.premiumFAR || 0,
        noOfBlocks: applicationData?.blocks?.length || 0,
        //premiumFAR: applicationData?.premiumFarArea || 0,
        demolitionArea: applicationData?.demolitionArea || null,
        parkingArea: applicationData?.parkingDetails?.overAllParkingArea || 0,
        parkingFloorNo: applicationData?.parkingDetails?.parkingFloorNo || 0,
        activeTab: Digit?.SessionStorage.get("MS_CURRENT_TAB") || 0,
        riskType: applicationData?.riskType,
        //applicationData: applicationData,
        applicationType,
        department: applicationFlow,
        feeType: "ApplicationFee",
        tod: {
            orientDevelopment: null,
            convertedLandUseinTOD: null,
        },
        planReport: applicationData?.planReport,
        updatedDxfFile: applicationData?.updatedDxfFile,
        dxfFile: applicationData?.dxfFile,
        workflow: { action: "INITIATE", assignes: null },
        landInfo: {
            owners: null,
            address: {
                city: applicationData?.district,
                locality: { code: "Lucknow" },
                region: null,
                doorNo: null,
                areaType: applicationData?.areaType,
            },
            tenantId,
        },
        professionaldetails: {
            name: userInfo?.info?.name,
            mobileNumber: userInfo?.info?.mobileNumber,
            emailId: userInfo?.info?.emailId,
        },
        landAreaDetails: {
            city: toTitleCase(applicationData?.correspondenceAddress?.district) || null,
            locality: {
                name: toTitleCase(applicationData?.correspondenceAddress?.tehsil) || null,
            },
            village: {
                name: toTitleCase(applicationData?.correspondenceAddress?.town) || null,
            },
            areaType: applicationData?.areaType,
        },
        businessService: applicationData?.businessService ||
            (applicationFlow === "DA"
                ? "BPA_MAPSUB_DA"
                : "BPA_MAPSUB_AVP"),
        documents,
        viewPdf: applicationData?.viewPdf,
        viewPlanReport: applicationData?.viewPlanReport,
        natureOfConstruction: applicationData?.natureOfConstruction,
        proposalType: applicationData?.proposalType,
        sanctionDate: applicationData?.sanctionDate,
        sanctionNumber: applicationData?.sanctionNumber,
        noOfPlots: applicationData?.noOfPlots,
        plotNumbers: applicationData?.plotNumbers,
        district: applicationData?.district,
        sectorNoPlotNo: applicationData?.sectorNoPlotNo,
        tehsil: applicationData?.tehsil,
        revenueVillage: applicationData?.revenueVillage,
        landMark: applicationData?.landMark,
        schemeName: applicationData?.schemeName,
        buildingClassification: applicationData?.buildingClassification,
        otherbuildingClass: applicationData?.otherbuildingClass,
        planOn: applicationData?.planOn,
        buildingHeight: applicationData?.buildingHeight,
        projectType: applicationData?.projectType,
        isRevised: applicationData?.isRevised,
        prevFileNo: applicationData?.prevFileNo,
        isSpecialProject: applicationData?.isSpecialProject,
        typeOfProject: applicationData?.typeOfProject,
        plotSubdivided: applicationData?.plotSubdivided,
        plotNo: applicationData?.plotNo,
        needCompounding: applicationData?.needCompounding,
        plotLeaseHold: applicationData?.plotLeaseHold,
        isApprovedLayout: applicationData?.isApprovedLayout,
        isSpecialGroundCoverage: applicationData?.isSpecialGroundCoverage,
        isSpecialFAR: applicationData?.isSpecialFAR,
        constructionType: applicationData?.constructionType,
        layoutsanctionNumber: applicationData?.layoutsanctionNumber,
        layoutsanctionDate: applicationData?.layoutsanctionDate,
        groundCoverage: applicationData?.groundCoverages,
        far: applicationData?.fars,
        isSetbackRequired: applicationData?.isSetbackRequired,
        setbackFronts: applicationData?.previousSetbackFront,
        setbackRears: applicationData?.previousSetbackRear,
        setbackSide1: applicationData?.previousSetbackSide1,
        setbackSide2: applicationData?.previousSetbackSide2,
        zoneType: applicationData?.zoneType,
        isMetroCity: applicationData?.isMetroCity,
        subZoneType: applicationData?.subZoneType,
        primaryUse: applicationData?.primaryUse,
        activityProposed: applicationData?.activityProposed,
        communityParking: applicationData?.communityParking,
        anyotherCondition: applicationData?.anyotherCondition,
        khasraNo: applicationData?.khasraNo,
        sectorNo: applicationData?.sectorNo,
        uiFlow: { flow: "Form12" },
        fastPASId: applicationData?.land_Id,
        scrutinyFlow: applicationData?.scrutinyFlow || (applicationData?.edcrNumber && "EDCR"),
        // schemeType: applicationData?.descriptionOfLand?.schemeType,
        typeOfArea: applicationData?.descriptionOfLand?.developmentArea,
        latitude: applicationData?.descriptionOfLand?.latitude,
        longitude: applicationData?.descriptionOfLand?.longitude,
        roadwidth: applicationData?.descriptionOfLand?.roadWidths?.[0]?.value,
        approachRoadWidth: applicationData?.descriptionOfLand?.approachRoadWidths?.[0]?.value,
        khasraDetails: applicationData?.khasraDetails,
        mapSubDetails: { proposalTypeFAR: applicationData?.mapSubDetails?.proposalTypeFAR, fireFighting: applicationData?.mapSubDetails?.fireFighting },
        descriptionOfLand: {
            ...applicationData?.descriptionOfLand,
            schemeType: applicationData?.descriptionOfLand?.schemeType,
        },

        landInfo: applicationData?.landInfo,
    };
    console.log("applicationDataFromOriginal", applicationData);

    return { applicationData, isAppDataLoading: false };
};

export default getSelfApprovalMapSubmissionData;